export class SuscripcionBoletaElectronica {
    _id_negociacion: Number;
    rut: String;
    nombre: String;
    telefono: String;
    email: String;
    numero_cliente: String;
    direccion: String;
    id_comuna: String;
    id_region: String;
    acepto_condiciones: Boolean;
    acepto_newsletters: Boolean;
    acepto_privacidad: Boolean;
    acepto_suscripcion: Boolean;
    token: String;
    ip: string;
 }